<template>
    <div :class="rootClass">
      <div class="container">
        <div :class="divClass2">
          <div class="block-split__item block-split__item-sidebar col-auto" v-if="categoryUri1 != 'ENGKT'">
            <faceted-panel 
              ref="faceted_panel"
              :level="level"
              :categoryUri1="categoryUri1"
              @view_parts="view_parts"
              @filter_changed="filter_changed"></faceted-panel>
          </div>
          <div class="block-split__item block-split__item-content col-auto">
            <page-display-options-search
                v-if="categoryUri1 != 'ENGKT'"
                @changePerPage="changePerPage"
                searchTerm="By Category"
                :total_results="numFound"
                @filterPrice="filterPrice"
                @filterAvailability="filterAvailability"
                @removeFilter="removeFilter"
                @clearAll="clearAll"
                ref="display_options"
              ></page-display-options-search>
            <div class="cart__table cart-table">
              <table class="cart-table__table">
                <thead class="cart-table__head">
                  <tr class="cart-table__row">
                    <th class="cart-table__column cart-table__column--numeral" v-if="categorydiagramimage">
                      Diagram
                    </th>
                    <th class="cart-table__column cart-table__column--image">
                      Image
                    </th>
                    <th class="cart-table__column cart-table__column--product">
                      Product
                    </th>
                    <th class="cart-table__column cart-table__column--price cart-table__column--parts-diagram-price">
                      Price
                    </th>
                    <th class="cart-table__column cart-table__column--quantity">
                      Quantity
                    </th>
                    <th class="cart-table__column cart-table__column--numeral" v-if="!isItemKit">
                      Availability
                    </th>
                    <th class="cart-table__column cart-table__column--total">
                      Total
                    </th>
                    <th class="cart-table__column cart-table__column--remove">
                      <img src="/images/spacer.png" width="20px" />
                    </th>
                  </tr>
                </thead>
                <tbody class="cart-table__body">
                    <product-list-item 
                    v-for="(product, indx) in parts"
                    :key="product.ID"
                    :index="indx"
                    :product="product"
                    :categorydiagramimage="categorydiagramimage">
  
                    </product-list-item>
                </tbody>
              </table>
  
              
            </div>
            <!-- pagination -->
            <div class="products-view__pagination">
              <nav class="Page navigation example">
                <base-pagination
                  :perPage="perPage"
                  :pages="pages"
                  :currentPage="page"
                  @updatePage="updatePage"
                ></base-pagination>
              </nav>
              <div class="products-view__pagination-legend">
                Showing {{ showing_page }} of {{ numFound }} products
              </div>
            </div>
            <!-- end pagination -->
          </div>
  
        </div>
      </div>
    </div>
    <base-spinner :open="isloading"></base-spinner>
  </template>
  
  <script>
  import ProductListItem from './ProductListItem.vue'
  import axiosvl from "../../../axios/axios-vl.js";
  import FacetedPanel from "../category/FacetedPanel";
  import SolrHelper from '../../../mixins/solr_helper';
  import axios from 'axios';
  import PageDisplayOptionsSearch from "../categorysearch/PageDisplayOptionsSearch";
  import BasePagination from "../../base/BasePagination.vue";
  
  export default {
      components : {
          ProductListItem,
          FacetedPanel,
          PageDisplayOptionsSearch,
          BasePagination
      },
      data() {
          return {
              numFound: 0,
              facets: {},
              facet_field_uri: '',
  
              more_filters: [],
              last_filter: null,
              partslen: 0,
              page : 1,
              perPage: 10,
              parts : [],
              pages: [],
              total_results: 0,
              showing: 0,
  
              products : [],
              isloading: false,
              categorydiagramimage: false,
              isItemKit: false,
  
              selected_filter: null,
              to_reloadlist: null,
          }
      },
  
      mixins:[SolrHelper],
  
      created() {
          console.log('CATEGORY 1 : ' + this.categoryUri1);
          if (this.categoryUri1 != 'ENGKT' ){
            this.solr_search(this.$store.getters.cat_faceted_filter);
          }else{
            this.getProducts();
          }
          
      },
  
      computed: {
        rootClass() {
          if(this.categoryUri1 != 'ENGKT'){
            return 'block-split block-split--has-sidebar';
          }
  
          return 'flexbox-container--vehicle-selection-form';
        },
        
        divClass2() {
          if(this.categoryUri1 != 'ENGKT'){
            return 'block-split__row row no-gutters';
          }
  
          return '';
        },
  
        /**show pages */
        showing_page() {
          let pagesShowing = '';
          let pg = this.page - 1;
          let startpg = pg * this.perPage;
          let endpg = '';
          if(startpg == 0){
            startpg = 1;
          }else{
            startpg += 1;
          }
  
          if(this.numFound < (this.page * this.perPage)){
            endpg = this.numFound;
          }else{
            endpg = this.page * this.perPage;
          }
  
          pagesShowing += startpg + '-' + endpg;
  
          return pagesShowing;
        }
      },
  
      props: {
        categoryUri1: {
          type: String
        }
      },
  
      methods: {
          updatePage(currentPage) {
            this.page = currentPage;
            this.solr_search(this.selected_filter, this.page);
          },
  
          total_items(total) {
            this.total_results = total;
            this.pages = [];
            let numberOfPages = Math.ceil(this.total_results / this.perPage);
            for (let index = 1; index <= numberOfPages; index++) {
              this.pages.push(index);
            }
          },
  
          getProducts() {
              let level = this.$route.params.level;
              let l = level;
              let lvl = 1;
              const categories = this.$store.getters['product/categories'];
              const user = this.$store.getters['customer'];
              if(level < 10){
                l = '0' + level;
              }
              let currentcategory = categories.filter((cat) => (cat['DMCD' + l] == this.$route.params['categoryUri' + level] && cat.categorylevel == level));

              while(lvl <= level){
                if(lvl < 10){
                    l = '0' + lvl;
                }else{
                    l = lvl;
                }
                currentcategory = currentcategory.filter((cat) => cat['DMCD' + l] == this.$route.params['categoryUri' + lvl]);
                lvl++;
              }
              
              
              // if current category not found
              // redirect to 404 page
              if (currentcategory == undefined){
                return
              }else{
                currentcategory = currentcategory[0];
              }
  
              this.isloading = true;
              const partslist_uri = this.$store.getters['api/partslist_uri'];
              // console.log('partslist_uri = ' + partslist_uri);
              axiosvl.post(partslist_uri, {
                  // parameters
                  webroutine: {
                      context: {
                      "session-key-method": "hidden",
                      },
                      fields: {
                          EHCUST: { value: user },
                          KL01: { value: currentcategory.DMCD01 },
                          KL02: { value: currentcategory.DMCD02 },
                          KL03: { value: currentcategory.DMCD03 },
                          KL04: { value: currentcategory.DMCD04 },
                          KL05: { value: currentcategory.DMCD05 },
                          KL06: { value: currentcategory.DMCD06 },
                          KL07: { value: currentcategory.DMCD07 },
                          KL08: { value: currentcategory.DMCD08 },
                          KL09: { value: currentcategory.DMCD09 },
                          KL10: { value: currentcategory.DMCD10 },
                      },
                  },
              })
              .then((response) => {
                  const CPARTS = response.data.webroutine.lists.CPARTS.entries;
                  
                  if (CPARTS.length > 0){
                    this.categorydiagramimage = (CPARTS[0].DMIMAG) ? true : false;
  
                    if (CPARTS[0].IUUMFG != 'KIT'){
                        this.isItemKit = false;
                    }else{
                        this.isItemKit = true;
                    }
                    
                  }else{
                    this.categorydiagramimage = false;
                  }
  
                  CPARTS.forEach(part => {
                    const clearProductDesc = encodeURIComponent(part.IMDESC);
  
                    part.IMMFGC = part.DMMFGC;
                    part.mfgSeo = part.MCNAME.replace(/ /g, "-"),
                    part.itemSeo = clearProductDesc.replace(/ /g, "-"),
                    this.parts.push(part);
                  });
  
                  this.isloading = false;
              })
              .catch(function (error) {
                  console.log("error - " + error);
                  this.isloading = false;
              });
          },
  
          async solr_search(filters = null, currentPage = 1) {
              const rows = this.perPage;
              const start = this.perPage * (currentPage - 1);
              // const custom_attr = this.$store.getters['product/custom_attrs'];
              const catCode = this.$route.params.categoryUri1;
              
              this.$emit('clear_messages');
              this.parts = [];
              this.more_filters = [];
              this.isloading = true;
  
              let filter_uri = '';
              if(filters != null){
                  filter_uri = this.mx_multi_facet_filter(filters);
              }else{
                  filter_uri = '&fq=Stocks:[1 TO *]';                 
                  // filter_uri += this.mx_get_filter();
                  filter_uri += this.mx_multi_facet_filter(filters);
              }
  
              this.level = this.$route.params.level;
              let lvl = 1;
              let l = '';
              while(lvl <= this.level){
  
                if(lvl < 10){
                  l = '0' + lvl;
                }else{
                  l = lvl;
                }
                // console.log('cat uri = ' + this.$route.params['categoryUri' + lvl]);
                filter_uri += '&fq=DMCD'+l+':' + this.$route.params['categoryUri' + lvl];
                lvl += 1;
              }
              console.log('filter uri = '  + filter_uri);
  
              const solr_host = this.$store.getters.solr_hostname + '/solr/' + this.$store.getters.solr_coreadmin;
              let uri = solr_host + '/select?q.op=AND&q=DMCD01%3A'+catCode+'&facet.field=IGDESC&facet.field=MCNAME&facet=true&f.B2C_price.facet.range.start=0&f.B2C_price.facet.range.end=1000&f.B2C_price.facet.range.gap=100&facet.range=B2C_price&f.Weight.facet.range.start=0&f.Weight.facet.range.end=100&f.Weight.facet.range.gap=10&facet.range=Weight';
              let paginate_uri = '&rows=' + rows+ '&start=' + start;
  
              uri += filter_uri + this.facet_field_uri + paginate_uri;
  
              // console.log('facet_field_uri = ' + this.facet_field_uri);
              // console.log('final uri = ' + uri);
  
              await axios.get(uri,{
                  auth: {
                      username: this.$store.getters.solr_username,
                      password: this.$store.getters.solr_password
                  }
              })
              .then((response) => {
                  const MPARTS = response.data.response.docs;
                  const resp_facets = response.data.facet_counts;
                  // console.log(MPARTS);
                  this.facets = resp_facets;
                  this.numFound = response.data.response.numFound;
  
                  MPARTS.forEach(obj => {
                      this.getProductDetails(obj);
                  });
                  
                  // this.$emit('facet_keys', this.facets);
                  this.facet_keys(this.facets);
  
                  // this.$emit('total_items', this.numFound);
                  this.total_items(this.numFound);
                  this.isloading = false;
              })
              .catch((error) => {
                  console.log("error - " + error);
                  this.isloading = false;
              });
          },
  
          async getProductDetails(product){
              // console.log(product);
              // console.log(image);
              await axiosvl.post(this.$store.getters['api/product_details_uri'], {
                  "webroutine": {
                      "context": {
                          "session-key-method": "hidden"
                      },   
                      "fields": {
                          "EHCUST": { "value": this.$store.getters.customer },
                          "EIMFGC": { "value": product.DXMFGC },
                          "EIITMC": { "value": product.Item },
                      },   
                  }
              })
              .then((response) => {
                  const fields = response.data.webroutine.fields;
  
                  if (fields.RESULTCOD.value === 'OK') {
                      // console.log(fields);
                      // const linetotal = 1 * fields.EIEXCP.value;
                      const defaultLoc = this.$store.getters.getCustomerDetails;
                      const clearProductDesc = encodeURIComponent(product.Item_Desc);
  
                      this.parts.push({
                          manufacturer: product.DXMFGC,
                          sku: product.Item,
                          DMITMC: product.Item,
                          // customer: obj.CMCUST,
                          location: defaultLoc,
                          IMMFGC: product.DXMFGC,
                          IUUMFG: product.MCNAME,
                          IMITMC: product.Item,
                          IMDESC: product.Item_Desc,
                          XRMFGC: '',
                          XRITMC: '',
                          DEDESC: '',
                          IMIGSA: product.IGCODE_SAG,
                          IMISVALID: '',
                          mfgSeo: product.MCNAME.replace(/ /g, "-"),
                          itemSeo: clearProductDesc.replace(/ /g, "-"),
                          // !NC! image: obj.EPIMG1,
                          image: product.Image,
  
                          // from Nic @ issue #260
                          // if it is B2B use QTYAVL
                          // if it is B2C use TOTOH
                          // stockquantity: (this.$store.getters.customerIndicator == 'B') ? fields.QTYAVL.value : fields.TOTOH.value,
                          stockquantity: product.Stocks,
                          QTYAVL: fields.QTYAVL.value,
                          TOTOH: fields.TOTOH.value,
                          // stockquantity: 1,
                          // stockqty: 1,
                          EILSTP: fields.EILSTP.value,
                          PRC: fields.EIEXCP.value,
                          EICORP: fields.EICORP.value,
                      });
                      // console.table(this.parts);
                  }else{
                      // console.log('not found product');
                      // console.log(product);
                      this.isloading = false;
                  }
              })
              .catch((error) => {
                  console.log("error - " + error);
              });
          },
  
          filter_changed(changed) {
            // console.log(changed);
            this.parts = [];
            clearTimeout(this.to_reloadlist);
          
            this.to_reloadlist = setTimeout(() => {
              this.selected_filter = changed;
              this.solr_search(changed);
            }, 500);
  
          },
  
          facet_keys(facets) {
              this.$refs.display_options.filter_changed(this.selected_filter, facets);
          },
  
          clearAll() {
              this.$refs.faceted_panel.removeFilter('all');
          },
  
          removeFilter(f) {
              this.$refs.faceted_panel.removeFilter(f[0]);
          },
  
          filterPrice(fval) {
            if(fval == 'HighToLow'){
                this.parts.sort((a,b) => (a.PRC < b.PRC) ? 1 : ((b.PRC < a.PRC) ? -1 : 0));
            }else{
                this.parts.sort((a,b) => (a.PRC > b.PRC) ? 1 : ((b.PRC > a.PRC) ? -1 : 0));
            }
          }
      },
  
  }
  </script>
  